module.exports = __webpack_public_path__ + "images/desktop/404.jpeg";